






















import { Vue, Component } from "vue-property-decorator";
import axios from "axios";

@Component
export default class Error extends Vue {
    returnLogin() {
        axios.get("/logoutAndLogin")
            .then(cb => {
                window.location.href = cb.data;
            })
            .catch(cb => {
              // ステータスコード503（過負荷 or メンテナンスモード）の場合、マイページに遷移する
              if (cb.response && cb.response.status === 503) {
                window.location.href = "/client/mypage";
              } else {
                console.error(cb);
              }
            });
    }
}
